// Imports
import { MyDetails } from 'src/modules/my-details-inner/jsx/component.jsx';
import { WantToLinks } from 'src/modules/i-want-to-links/jsx/component.jsx';

// Stateless components

export function MyDetailsPage(props) {

    //
    // Render
    //

    return (
        <>
            <MyDetails />
            <WantToLinks />
        </>
    );
};
